/* @flow */

import axios from 'axios';
import AxiosConfiguration from './AxiosConfiguration';
/* import LocalStorageService from '../services/LocalStorageService'; */

class ServiceConsumer {
  endpointUrl: string;

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl;
  }
}

export default ServiceConsumer;

/* Axios interceptor: REQUEST */
axios.interceptors.request.use(
  config => AxiosConfiguration.getRequestInterceptorSuccessHandler(config),
  error => AxiosConfiguration.getRequestInterceptorErrorHandler(error)
);

/* Axios interceptor: RESPONSE */
axios.interceptors.response.use(
  response => AxiosConfiguration.getResponseInterceptorSuccessHandler(response),
  error => AxiosConfiguration.getResponseInterceptorErrorHandler(error)
);

/**
 * Authorizartion bearer token is temporarily disabled
 * @see DL-724
 */

/*
const token = LocalStorageService.getAuthToken();
if (token) axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
*/
